import server from "src/api/server";
import dynamic from "next/dynamic";

import Seo from "src/components/shared/Seo";
import { useRouter } from "next/router";

const SingleService = dynamic(() =>
  import("src/modules/ServicePage/ServicePage")
);
export default function SingleServicePage({
  data,
  appSetting = {},
  footerSettings,
}) {
  const router = useRouter();
  const { locale } = router;

  const customMeta = [
    { name: "title", content: data?.singleServiceData?.title?.[locale] },
    {
      name: "description",
      content: data?.singleServiceData?.description?.[locale],
    },
  ];

  return (
    <>
      <Seo
        metaData={customMeta}
        appSetting={{
          ...appSetting,
          ...footerSettings,
        }}
        pageUrl={
          typeof window !== "undefined"
            ? window.location.href
            : `${process.env.NEXT_PUBLIC_SITE_URL}/${router.asPath}`
        }
      />
      <div>
        <SingleService data={data} />
      </div>
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}
export async function getStaticProps({ params }) {
  const slug = params?.slug || "";
  if (!/^[-a-zA-Z0-9]+$/.test(slug)) {
    return { notFound: true, revalidate: 30 };
  }

  try {
    const singleServiceRes = await server.get(
      `/api/services/getBySlug/${slug}`
    );
    const singleServiceData = singleServiceRes?.data?.data;

    if (!singleServiceData) {
      return { notFound: true, revalidate: 30 };
    }

    const [AllServicesRes, indexRes, testmonialsRes, questionsRes, footerRes] =
      await Promise.all([
        server.get(`/api/services`),
        server.get("/api/index"),
        server.get("/api/posts/opinions/all"),
        server.get("/api/posts/questions/all"),
        server.get("/api/footer"),
      ]);

    const AllServicesData = AllServicesRes?.data?.data || null;
    const indexData = indexRes?.data?.data;
    const appSetting = indexData?.AppSetting || null;
    const testmonialsData = testmonialsRes?.data?.data || null;
    const questions = questionsRes?.data?.data || null;
    const footerSettings = footerRes?.data?.data || null;

    return {
      props: {
        data: {
          singleServiceData,
          AllServicesData,
          testmonialsData,
          questions,
        },
        appSetting,
        footerSettings,
      },
      revalidate: 60,
    };
  } catch (e) {
    return { notFound: true, revalidate: 30 };
  }
}
